'use client';

import { useContext } from 'react';
import { AppLogo, DEFAULT_LOGO_SIZE } from '../AppLogo/AppLogo.use-client';
import { UserInfoContext } from '../../../../common/userinfo/UserInfoContext/UserInfoContext';

const AppLogoWithIslamicProp = ({
  size = DEFAULT_LOGO_SIZE,
  textLogoSize,
  color,
  noText,
}: {
  size?: number;
  textLogoSize?: number;
  color?: string;
  noText?: boolean;
}) => {
  const { isIslamicUser } = useContext(UserInfoContext).data ?? {};

  return (
    <AppLogo
      size={size}
      textLogoSize={textLogoSize}
      color={color}
      isIslamicUser={isIslamicUser}
      noText={noText}
    />
  );
};

export { AppLogoWithIslamicProp };
